module.exports = __webpack_public_path__ + "static/media/judge-info.feb46dfa.png";